import React from "react";

// Renders one operative legal document (Terms or Privacy) from legalText.js.
export const LegalDocument = ({ doc, className = "" }) => (
  <article id={doc.id} data-testid={`legal-doc-${doc.id}`} className={className}>
    <h2 className="font-heading text-xl font-bold text-tc-txt">{doc.title}</h2>
    <p className="mt-3 text-sm text-tc-sub leading-relaxed">{doc.intro}</p>
    {doc.sections.map((s) => (
      <section key={s.heading} className="mt-5">
        <h3 className="font-heading text-sm font-semibold text-tc-txt">{s.heading}</h3>
        {(s.paragraphs || []).map((p) => (
          <p key={p.slice(0, 40)} className="mt-2 text-sm text-tc-sub leading-relaxed">{p}</p>
        ))}
        {s.list && (
          <ul className="mt-2 list-disc pl-5 space-y-1 text-sm text-tc-sub leading-relaxed">
            {s.list.map((li) => <li key={li.slice(0, 40)}>{li}</li>)}
          </ul>
        )}
      </section>
    ))}
  </article>
);
